import { AvatarData } from '@components/AvataarsPicker/types'

export enum TopType {
  NoHair = 0,
  Eyepatch = 1,
  Hat = 2,
  Hijab = 3,
  Turban = 4,
  WinterHat1 = 5,
  WinterHat2 = 6,
  WinterHat3 = 7,
  WinterHat4 = 8,
  LongHairBigHair = 9,
  LongHairBob = 10,
  LongHairBun = 11,
  LongHairCurly = 12,
  LongHairCurvy = 13,
  LongHairDreads = 14,
  LongHairFrida = 15,
  LongHairFro = 16,
  LongHairFroBand = 17,
  LongHairNotTooLong = 18,
  LongHairShavedSides = 19,
  LongHairMiaWallace = 20,
  LongHairStraight = 21,
  LongHairStraight2 = 22,
  LongHairStraightStrand = 23,
  ShortHairDreads01 = 24,
  ShortHairDreads02 = 25,
  ShortHairFrizzle = 26,
  ShortHairShaggyMullet = 27,
  ShortHairShortCurly = 28,
  ShortHairShortFlat = 29,
  ShortHairShortRound = 30,
  ShortHairShortWaved = 31,
  ShortHairSides = 32,
  ShortHairTheCaesar = 33,
  ShortHairTheCaesarSidePart = 34
}

export enum HairColor {
  Auburn = 0,
  Black = 1,
  Blonde = 2,
  BlondeGolden = 3,
  Brown = 4,
  BrownDark = 5
}

export enum AccessoriesType {
  Blank = 0,
  Kurt = 1,
  Prescription01 = 2,
  Prescription02 = 3,
  Round = 4,
  Sunglasses = 5,
  Wayfarers = 6
}

export enum FacialHairType {
  Blank = 0
}

export enum ClothingType {
  BlazerShirt = 0,
  BlazerSweater = 1,
  CollarSweater = 2,
  GraphicShirt = 3,
  Hoodie = 4,
  Overall = 5,
  ShirtCrewNeck = 6,
  ShirtScoopNeck = 7
}

export enum ClothingColor {
  Black = 0,
  Blue01 = 1,
  Blue02 = 2,
  Blue03 = 3,
  Gray01 = 4,
  Gray02 = 5,
  Heather = 6,
  PastelBlue = 7,
  PastelGreen = 8,
  PastelOrange = 9,
  PastelRed = 10,
  PastelYellow = 11,
  Pink = 12,
  Red = 13,
  White = 14
}

export enum EyeType {
  Default = 0,
  Close = 1,
  Cry = 2,
  Dizzy = 3,
  EyeRoll = 4,
  Happy = 5,
  Hearts = 6,
  Side = 7,
  Squint = 8,
  Surprised = 9,
  Wink = 10,
  WinkWacky = 11
}

export enum EyebrowType {
  Angry = 0,
  AngryNatural = 1,
  Default = 2,
  DefaultNatural = 3,
  FlatNatural = 4,
  RaisedExcited = 5,
  RaisedExcitedNatural = 6,
  SadConcerned = 7,
  SadConcernedNatural = 8,
  UnibrowNatural = 9,
  UpDown = 10,
  UpDownNatural = 11
}

export enum MouthType {
  Concerned = 0,
  Default = 1,
  Disbelief = 2,
  Eating = 3,
  Grimace = 4,
  Sad = 5,
  ScreamOpen = 6,
  Serious = 7,
  Smile = 8,
  Tongue = 9,
  Twinkle = 10,
  Vomit = 11
}

export enum SkinColor {
  Tanned = 0,
  Yellow = 1,
  Pale = 2,
  Light = 3,
  Brown = 4,
  DarkBrown = 5,
  Black = 6
}

export enum AvatarStyle {
  Circle = 0
}

export enum Gender {
  Boy = 0,
  Girl = 1,
  Other = 2
}
export const enumMap = {
  topType: TopType,
  hairColor: HairColor,
  accessoriesType: AccessoriesType,
  facialHairType: FacialHairType,
  clothingType: ClothingType,
  clothingColor: ClothingColor,
  eyeType: EyeType,
  eyebrowType: EyebrowType,
  mouthType: MouthType,
  skinColor: SkinColor,
  avatarStyle: AvatarStyle,
  gender: Gender
}

export function convertEnumValues(
  source: any,
  enumMap: { [K in keyof any]?: any }
): AvatarData {
  return Object.entries(source).reduce((acc, [key, value]) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const enumObj = enumMap[key]
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const convertedValue =
      enumObj && typeof value === 'number' ? enumObj[value] : value

    // Rename keys if needed
    let outputKey = key
    if (key === 'clothingType') {
      outputKey = 'clotheType'
    } else if (key === 'clothingColor') {
      outputKey = 'clotheColor'
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    acc[outputKey] = convertedValue
    return acc
  }, {} as AvatarData)
}

export function convertEnumStringsToNumbers<T extends Record<string, any>>(
  source: T,
  enumMap: Record<string, any>
): Record<string, number> {
  // Step 1: Create a shallow copy of the object excluding clothingType and clothingColor
  const { clothingType, clothingColor, ...rest } = source

  // Step 2: Rename clotheType and clotheColor to clothingType and clothingColor
  const renamed = {
    ...rest,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    clothingType: source.clotheType,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    clothingColor: source.clotheColor
  }

  // Step 3: Convert strings to numbers using enum maps
  return Object.fromEntries(
    Object.entries(enumMap).map(([key, enumObj]) => {
      const value = renamed[key]
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const numericValue =
        typeof value === 'string' && value in enumObj ? enumObj[value] : value
      return [key, numericValue]
    })
  )
}
